import { faker } from '@faker-js/faker'
import { defineFakeRoute } from 'vite-plugin-fake-server/client'

const AllList: any[] = []
for (let i = 0; i < 20; i++) {
  const status = ['0', '1', '2'][Math.floor(Math.random() * 3)]
  AllList.push({
    id: i + 1,
    tenantId: `TENANT${String(i + 1).padStart(4, '0')}`,
    tenantName: faker.company.name(),
    currentExpireDate: faker.date.future().toISOString().split('T')[0],
    extensionDays: Math.floor(Math.random() * 30) + 1,
    reason: faker.lorem.sentence(),
    status: status,
    approvalOpinion: status !== '0' ? faker.lorem.sentence() : '',
    approverId: status !== '0' ? String(Math.floor(Math.random() * 100) + 1) : '',
    approverName: status !== '0' ? faker.person.fullName() : '',
    approvedAt: status !== '0' ? faker.date.past().toISOString() : '',
    applicant: faker.person.fullName(),
    createdAt: faker.date.past().toISOString(),
    updatedAt: faker.date.past().toISOString(),
  })
}

export default defineFakeRoute([
  {
    url: '/mock/tenant/tenant_extension_requests/list',
    method: 'get',
    response: ({ query }) => {
      const { tenantName, status, startTime, endTime, from, limit } = query
      let list = [...AllList]

      if (tenantName) {
        list = list.filter((item) => item.tenantName.includes(tenantName))
      }
      if (status) {
        list = list.filter((item) => item.status === status)
      }
      if (startTime) {
        list = list.filter((item) => item.createdAt >= startTime)
      }
      if (endTime) {
        list = list.filter((item) => item.createdAt <= endTime)
      }

      const pageList = list.filter((_, index) => {
        return index >= ~~from && index < (~~from + ~~limit)
      })

      return {
        error: '',
        status: 1,
        data: [pageList, list.length],
      }
    },
  },
  {
    url: '/mock/tenant/tenant_extension_requests/:id',
    method: 'get',
    response: ({ params }) => {
      const info = AllList.find((item) => item.id === Number(params.id))
      return {
        error: '',
        status: 1,
        data: info || {},
      }
    },
  },
  {
    url: '/mock/tenant/tenant_extension_requests',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          isSuccess: true,
        },
      }
    },
  },
  {
    url: '/mock/tenant/tenant_extension_requests/:id/approve',
    method: 'post',
    response: ({ params }) => {
      const item = AllList.find((item) => item.id === Number(params.id))
      if (item) {
        item.status = '1'
        item.approvalOpinion = '审批通过'
        item.approverName = '管理员'
        item.approvedAt = new Date().toISOString()
      }
      return {
        error: '',
        status: 1,
        data: {
          isSuccess: true,
        },
      }
    },
  },
  {
    url: '/mock/tenant/tenant_extension_requests/:id/reject',
    method: 'post',
    response: ({ params }) => {
      const item = AllList.find((item) => item.id === Number(params.id))
      if (item) {
        item.status = '2'
        item.approvalOpinion = '审批拒绝'
        item.approverName = '管理员'
        item.approvedAt = new Date().toISOString()
      }
      return {
        error: '',
        status: 1,
        data: {
          isSuccess: true,
        },
      }
    },
  },
  {
    url: '/mock/tenant/tenant_extension_requests/:id',
    method: 'delete',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          isSuccess: true,
        },
      }
    },
  },
  {
    url: '/mock/tenant/tenant_extension_requests/batch-approve',
    method: 'post',
    response: ({ body }) => {
      body.ids.forEach((id: number) => {
        const item = AllList.find((item) => item.id === id)
        if (item) {
          item.status = '1'
          item.approvalOpinion = '批量审批通过'
          item.approverName = '管理员'
          item.approvedAt = new Date().toISOString()
        }
      })
      return {
        error: '',
        status: 1,
        data: {
          isSuccess: true,
        },
      }
    },
  },
  {
    url: '/mock/tenant/tenant_extension_requests/batch-reject',
    method: 'post',
    response: ({ body }) => {
      body.ids.forEach((id: number) => {
        const item = AllList.find((item) => item.id === id)
        if (item) {
          item.status = '2'
          item.approvalOpinion = '批量拒绝'
          item.approverName = '管理员'
          item.approvedAt = new Date().toISOString()
        }
      })
      return {
        error: '',
        status: 1,
        data: {
          isSuccess: true,
        },
      }
    },
  },
])
